import Link from '@/components/Link/Link';
import tw, { styled } from 'twin.macro';

export const Container = styled.div`
  ${tw`gap-y-3`}
`;

export const LoginLinksContainer = styled.ul`
  ${tw`flex flex-col gap-y-2`}
`;

export const StyledSSOLink = styled(Link)`
  ${tw`w-full`}
`;

export const SSOLinkContainer = styled.div`
  ${tw`flex justify-center`}
`;

export const LegalTextContainer = styled.div`
  ${tw`text-body-xs text-neutrals-n7`}
  ${tw`font-inter font-regular`}
  ${tw`mt-2`}

  a {
    ${tw`underline`}
  }
`;

export const SeparatorWrapper = styled.div`
  ${tw`relative`}
  ${tw`text-center`}
  ${tw`overflow-hidden`}
  ${tw`my-3`}
`;

export const SeparatorText = styled.span`
  ${tw`text-primary-p1 text-heading-s`}
  ${tw`font-semi-bold`}
  ${tw`align-middle`}

  &::before,
  &::after {
    content: '';
    ${tw`absolute`}
    ${tw`top-[48%]`}
    ${tw`inline-block w-1/2 h-[2px]`}
    ${tw` bg-ui-colours-ui3`}
  }
  &::before {
    ${tw`-right-3`}
  }
  &::after {
    ${tw`-left-3`}
  }
`;
